import * as tslib_1 from "tslib";
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Proto } from 'typescript-proto-decorator';
import { Translator } from '../Translate/Translator';
import { ContributionCountElement } from '../Translate/types/ContributionCountElement';
/** Details about the hovered day */
var DayDetails = (function () {
    function DayDetails() {
    }
    tslib_1.__decorate([
        Proto(ContributionCountElement),
        tslib_1.__metadata("design:type", Number)
    ], DayDetails.prototype, "ccEl", void 0);
    tslib_1.__decorate([
        Input('count'),
        tslib_1.__metadata("design:type", Number)
    ], DayDetails.prototype, "count", void 0);
    tslib_1.__decorate([
        Input('date'),
        tslib_1.__metadata("design:type", Date)
    ], DayDetails.prototype, "date", void 0);
    tslib_1.__decorate([
        Input('tr'),
        tslib_1.__metadata("design:type", Translator)
    ], DayDetails.prototype, "tr", void 0);
    DayDetails = tslib_1.__decorate([
        Component({
            changeDetection: ChangeDetectionStrategy.OnPush,
            selector: 'gh-contrib-calendar-details',
            styles: [require('./DayDetails.scss')],
            template: require('./DayDetails.pug')
        })
    ], DayDetails);
    return DayDetails;
}());
export { DayDetails };



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/DayDetails/DayDetails.ts
// module id = 32
// module chunks = 0 1